import { render, staticRenderFns } from "./box-input.vue?vue&type=template&id=7ec6d751&scoped=true&"
import script from "./box-input.vue?vue&type=script&lang=js&"
export * from "./box-input.vue?vue&type=script&lang=js&"
import style0 from "./box-input.vue?vue&type=style&index=0&id=7ec6d751&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec6d751",
  null
  
)

export default component.exports